export default __webpack_public_path__ + "static/media/hht2_ep09_timeline_q04_a.4454228c.png";